//
// Digital Services Common Components provide us not only with `<Dialog>` component but also with hook `useDialog()` which returns a `showDialog()` function.
// Since at least `v0.70.6` there was also a fix to support `Esc` button press to close/cancel Dialog.
//
// Current maintainers implemented that way that
// - if `onClose()` provided then `x` icons is shown and clickable, and Dialog is then ALSO `Escape`-able.
// - if `onCancel()` provided, then Cancel button will be shown and forced to be clicked, but Dialog then is NOT `Escape`-able.
//
// To avoid not being able to Escape Dialog instance, we provide both functions
export const defaultTriggerDialogOptions = {
  onCancel: () => {
    // Use case when `Cancel` button is clicked
    // Doesn't "enable" `closeOnEscape` feature
  },
  onClose: () => {
    // Use case when `x` icon is clicked
    // Especially this function MUST be provided so that `closeOnEscape` feature is indeed working
  }
  // When custom logic for any of these functions needed, implement in custom component
};
